export * from './ErrorTip';
export { default as ErrorTip } from './ErrorTip';
